import React from 'react';
import { Link } from 'react-router-dom';
import './Layout.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Navigation</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/prices">Prices</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact Us</h3>
            <address>
              <p><strong>Clinic:</strong></p>
              <p>28 Barking Rd</p>
              <p>London E16 1EQ</p>
              <p style={{ marginTop: '1rem' }}>Phone: +44 7577151625</p>
              <p>Email: admin@sapiumbeauty.com</p>
            </address>
          </div>

          <div className="footer-section">
            <h3>Follow Us</h3>
            <div className="social-links">
              <a 
                href="https://www.instagram.com/sapiumbeauty/" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="social-link"
              >
                Instagram
              </a>
              <a 
                href="https://www.facebook.com/people/Sapium-Beauty/61584775406444/" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="social-link"
              >
                Facebook
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Sapium Beauty. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 